// import components
import { styled, Box } from '@mui/material';

export const StyledEditProjectPageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 4, 4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4)
}));

export const StyledEditProjectTopContent = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  position: 'relative'
}));

export const StyledAutocompleteBox = styled(Box)(() => ({
  minWidth: '200px'
}));
